import FileUpload from '@/modules/upload/models';

interface UploadState {
  files: Array<FileUpload>,
  rejectedFiles: Array<FileUpload>,
  completedFiles: Array<FileUpload>
}

const state: UploadState = {
  files: [],
  rejectedFiles: [],
  completedFiles: [],
};

const mutations = {
  ADD_FILE_UPLOAD(state: UploadState, fileUpload: FileUpload) {
    state.files.push(fileUpload);
  },
  REJECT_FILE_UPLOAD(state: UploadState, fileUpload: FileUpload) {
    state.files.splice(state.files.indexOf(fileUpload), 1);
    state.rejectedFiles.push(fileUpload);
  },
  UPDATE_FILE_PROGRESS(state: UploadState, { fileUpload, progress }) {
    state.files[state.files.indexOf(fileUpload)].progress = Math.round(progress);
  },
  COMPLETE_FILE_UPLOAD(state: UploadState, fileUpload: FileUpload) {
    state.files.splice(state.files.indexOf(fileUpload), 1);
    state.completedFiles.push(fileUpload);
  },
  // Se ejecuta cuando se clica sobre el botón de success para ir
  // a la edición del vídeo
  CLEAR_FILE_UPLOAD(state: UploadState, fileUpload: FileUpload) {
    state.completedFiles.splice(state.completedFiles.indexOf(fileUpload), 1);
  },
};

const actions = {
  async UPLOAD_WITH_PRESIGNED_URL({ commit }, {
    file, type, collectionId, name,
  }) {
    try {
      const fileUpload = new FileUpload({
        file, type, collectionId, filename: name,
      });
      commit('ADD_FILE_UPLOAD', fileUpload);
      await fileUpload.createUpload();
      return fileUpload;
    } catch (err) {
      console.error('Could not upload file.', err);
      return false;
    }
  },
};

const getters = {
  completedFiles(state: UploadState): Array<FileUpload> {
    return state.completedFiles;
  },
  rejectedFiles(state: UploadState): Array<FileUpload> {
    return state.rejectedFiles;
  },
  allFiles(state: UploadState): Array<FileUpload> {
    return state.files.concat(state.completedFiles, state.rejectedFiles);
  },
  hasFiles(state: UploadState, getters): boolean {
    return getters.allFiles.length !== 0;
  },
  processingFilesCount: (state: UploadState): number => state.files.length,
  completedFilesCount: (state: UploadState) : number => state.completedFiles.length,
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
};
